import { BrowserRouter as Router, Routes } from 'react-router-dom'
import MainRoutes from './routes/mainRoutes' 

const App = () => {
  return (
    <Router>
      <Routes>
        {MainRoutes()} 
      </Routes>
    </Router>
  )
}

export default App